import { onReady } from '../base/init.js';
import { loadSwiper } from '../base/swiper-lazy.js';

function initIntro() {
  const el = document.getElementById('intro-swiper');
  if (!el) return;

  // Один слайд — Swiper не нужен (и не качается): его инициализация только меняет
  // высоту hero (даёт CLS) и читает геометрию (forced reflow ~100мс), без пользы.
  // Слайд и так отрисован CSS-раскладкой трека (.swiper-wrapper{display:flex}
  // пока нет swiper-initialized).
  const multi = el.querySelectorAll('.swiper-slide').length > 1;
  if (!multi) return;

  loadSwiper().then((Swiper) => {
    if (!Swiper || el.swiperInstance) return;
    initIntroSwiper(el, Swiper);
  });
}

function initIntroSwiper(el, Swiper) {
  el.swiperInstance = new Swiper(el, {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 800,
    // initIntroSwiper вызывается только при нескольких слайдах (см. guard выше)
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: false },
    navigation: {
      nextEl: el.querySelector('.intro__next'),
      prevEl: el.querySelector('.intro__prev'),
    },
    pagination: {
      el: el.querySelector('.intro__pagination'),
      clickable: true,
    },
  });
}

onReady(initIntro);
